import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CountdownConfig } from 'ngx-countdown';
import * as QRCode from 'qrcode';
import { Subscription } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { AgendamentoService } from 'src/app/services/AgendamentoService/agendamento.service';
import {
  ICreatePagamentoPix,
  ICreatePagamentoPixResponse,
  ICreatePagamentoWithAntifraudeResponse,
  IGetPagamentoIncompletoByAgendamento
} from 'src/app/services/PagamentoService/pagamento.model';
import { PagamentoService } from 'src/app/services/PagamentoService/pagamento.service';
import { PrecoService } from 'src/app/services/PrecoService/preco.service';
import Swal from 'sweetalert2';
import { UserIpService } from 'src/app/services/UserIpService/userIp.service';
import data from '../../../../../appsettings.json';
import { formatarData } from 'src/app/core/utils/utilities';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { HubConnectionService } from 'src/app/services/HubConnectionService/hubConnection.service';

type IOptions = {
  name: string;
  value: string | number;
  listaIndex?: number;
};

declare var csdp: any;

@Component({
  selector: 'app-cadastro-pagamento-agendamento',
  templateUrl: './cadastro-pagamento-agendamento.component.html',
  styleUrls: ['./cadastro-pagamento-agendamento.component.scss']
})
export class CadastroPagamentoAgendamentoEmpresaComponent
  implements OnInit, OnDestroy, OnChanges, AfterViewInit
{
  private subscription$ = new Subscription();
  isFormValid: boolean = true;
  qrcodeUrl: string = '';
  qrcodetext: string = '';
  form: FormGroup;
  dataExpiracao: string = '';
  countdownConfig!: CountdownConfig;
  title: string = 'Pagamento';
  isLoading: boolean = false;
  idAgendamento: number = 0;
  idPagamento: number = 0;
  guid = generateUUID();
  statusInput: boolean = false;
  activeRoute: string = '';
  isCartao: boolean = false;
  isDebit: boolean = false;
  isPagamentoPixVisivel: boolean = false;
  status: number = 1;
  urlDebito: string = '';
  ifAfterPost: boolean = false;

  sessionID: string = '';
  ipAddress: string = '';

  hubName = 'pingHubPointing';
  hubReceiveName = 'pingHubPointingReceive';

  pagamentoOptions: IOptions[] = [
    {
      name: 'Pix',
      value: 'pix'
    },
    {
      name: 'Crédito',
      value: 'credit'
    },
    {
      name: 'Débito',
      value: 'debit'
    }
  ];

  bandeiraCartaoOptions: IOptions[] = [
    {
      name: 'Mastercard',
      value: 2
    },
    {
      name: 'Visa',
      value: 3
    },
    {
      name: 'Cartão Elo',
      value: 10
    },
    {
      name: 'Diners',
      value: 1
    },
    {
      name: 'HiperCard',
      value: 6
    },
    {
      name: 'American Express',
      value: 5
    },
    {
      name: 'Aura',
      value: 7
    },
    {
      name: 'NCard',
      value: 40
    },
    {
      name: 'LeaderCard',
      value: 50
    },
    {
      name: 'Fortbrasil',
      value: 100
    },
    {
      name: 'Sorocred',
      value: 101
    },
    {
      name: 'Cartão Mais!',
      value: 103
    },
    {
      name: 'Cartão C&A',
      value: 105
    },
    {
      name: 'A Vista',
      value: 102
    },
    {
      name: 'Outros',
      value: 4
    }
  ];

  teste: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private pagamentoService: PagamentoService,
    private agendamentoService: AgendamentoService,
    private precoService: PrecoService,
    private userIpService: UserIpService,
    private hubConnectionService: HubConnectionService,
    private swalAlert: SwalAlertService
  ) {
    this.form = this._inicializarFormulario();
  }

  private _inicializarFormulario() {
    const form = this.fb.group({
      VL_SRVC: [0, [Validators.required]],
      NU_TIPO_PAGM: [0, [Validators.required]],
      NM_CART: ['', [Validators.required]],
      NU_CART: ['', [Validators.required, Validators.minLength(16)]],
      DT_EXPC: ['', [Validators.required]],
      CD_SEGU: ['', [Validators.required, Validators.minLength(3)]],
      BND_CART: ['', [Validators.required]]
    });

    return form;
  }

  ngOnInit(): void {
    this.form.controls[`VL_SRVC`].disable();
    this.statusAgendamento();
    this.loadClearSaleSession();

    this.hubConnectionService.configureHub(this.hubName, this.hubReceiveName);
    this.hubConnectionService.getMessages().subscribe(msg => {
      this.swalAlert.showAlert(
        'Pagamento realizado com sucesso!',
        msg.message,
        'success',
        false,
        false,
        undefined
      );

      this.router.navigate(['empresa/listagem/agendamento']);
    });
  }

  ngAfterViewInit(): void {
    this.getIpAddress();
  }

  ngOnDestroy(): void {
    this;

    this.subscription$.unsubscribe();

    this.hubConnectionService.stopConnection();
  }

  ngOnChanges(changes: SimpleChanges): void {}

  inicializarCountdown(dateExpiration?: string | Date) {
    let targetDate: number;

    if (dateExpiration) {
      targetDate = new Date(dateExpiration).getTime();
    } else {
      targetDate = new Date(this.dataExpiracao).getTime();
    }

    const currentTime = new Date().getTime();
    const timeLeft = targetDate - currentTime;

    const timeLeftInSeconds = Math.floor(timeLeft / 1000);

    this.countdownConfig = {
      leftTime: timeLeftInSeconds,
      format: 'HH:mm:ss',
      notify: 0
    };
  }

  handleEvent(event: any) {
    if (event.action === 'done') {
      this.router.navigate(['empresa/listagem/agendamento']);

      this.swalAlert.showAlert(
        'Pagamento não efetuado.',
        'O pagamento não foi realizado na janela dos 15 minutos, necessário realizar o novo agendamento, pois este encontra-se cancelado.',
        'warning',
        false,
        false,
        undefined
      );
    }
  }

  statusAgendamento(): number {
    this.route.queryParams.subscribe(params => {
      this.idAgendamento = Number(params['PK_AGND']);

      let rawValue = params['VL_SRVC']
        .replace(/\s/g, '') // remove espaços
        .replace('R$', '') // remove R$
        .replace('.', '') // remove separador de milhar
        .replace(',', '.'); // troca vírgula por ponto decimal

      const valorNumerico = Number(rawValue);

      this.form.controls['VL_SRVC'].setValue(
        valorNumerico.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        })
      );

      if (Boolean(params['FL_INCP']))
        this.verifyPagamentoByAgendamento(this.idAgendamento);
    });
    return this.status;
  }

  createPayload(): any {
    const inputDate = this.form.controls['DT_EXPC'].value;
    const mes: number = Number(inputDate.substring(0, 2));
    const ano: number = Number(inputDate.substring(2, 6));
    return {
      postTransacaoAutorizacao: {
        NM_PORT_CART: this.form.controls['NM_CART'].value,
        NU_EXPR_ANO_CART: ano,
        NU_EXPR_MES_CART: mes,
        PK_AGND: this.idAgendamento,
        TX_CART_NUMB: this.form.controls['NU_CART'].value,
        TX_CVV_CART: this.form.controls['CD_SEGU'].value,
        TX_TIPO_TRSC: this.form.controls['NU_TIPO_PAGM'].value,
        postTransacaoThreeDSecureDto: {
          TX_USER_AGNT: navigator.userAgent,
          NU_COLR_DPTH: screen.colorDepth,
          TX_DVCE_TYPE: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
            ? 'mobile'
            : 'desktop',
          FL_JAVA_ENBL: window.navigator.javaEnabled(),
          TX_LANG: navigator.language,
          NU_SCRN_HGHT: window.innerHeight,
          NU_SCRN_WDTH: window.innerWidth,
          NU_TIME_ZONE: Math.abs(new Date().getTimezoneOffset() / 60)
        }
      },
      sessionID: this.getSessionId(),
      ip: this.ipAddress,
      bandeiraCartaoCredito: this.form.controls['BND_CART'].value
    };
  }

  postarDados() {
    if (this.form.valid) {
      this.isLoading = true;
      if (!this.isCartao) {
        return;
      }
      if (this.tipoAcesso()) {
        const payload = this.createPayload();
        this.pagamentoService
          .CreatePagamentoWithAntifraude(payload, this.guid)
          .subscribe({
            next: (response: ICreatePagamentoWithAntifraudeResponse) => {
              const isTipoAcesso: boolean = this.tipoAcesso();
              this.isLoading = false;
              this.form.disable();
              this.isFormValid = false;
              this.isCartao = false;
              this.urlDebito = response.url;
              this.ifAfterPost = true;

              if (!this.isDebit) {
                this.swalAlert.showAlert(
                  'Sucesso!',
                  'Pagamento realizado com sucesso, aguarde atualização para retirada do ticket do agendamento.',
                  'success',
                  false,
                  false,
                  undefined
                );

                if (isTipoAcesso) {
                  this.router.navigate(['empresa/listagem/agendamento']);
                }
              }
            },
            error: (error: any) => {
              this.swalAlert.handleError(
                error,
                'Atenção!',
                'Ocorreu um erro ao realizar o pagamento, por favor, tente novamente.',
                'warning'
              );
              this.router.navigate(['empresa/listagem/agendamento']);
              this.isLoading = false;
            }
          });
      }
    } else {
      this.swalAlert.showAlert(
        'Atenção',
        'Verifique se todos os campos obrigatórios foram preenchidos corretamenta.',
        'warning',
        false,
        false,
        undefined
      );
    }
  }

  goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  escolherTipoPagamento(value: any): void {
    const confirmarPix = () => {
      Swal.fire({
        title: 'Deseja continuar com pagamento PIX?',
        text: 'Não será possível alterar esta escolha!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'green',
        cancelButtonColor: 'red',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
      }).then(result => {
        if (result.isConfirmed) {
          this.form.controls['NU_TIPO_PAGM'].disable();
          this.processarPagamento(value);
        } else if (result.isDenied || result.isDismissed) {
          this.form.controls['NU_TIPO_PAGM'].setValue(0);
        }
      });
    };

    if (value === 'pix') {
      // Prevenir que o modal abra 2X
      if (this.form.controls['NU_TIPO_PAGM'].value != 'pix') confirmarPix();
    } else {
      this.isDebit = value === 'debit';
      this.processarPagamento(value);
    }
  }

  private processarPagamento(value: any): void {
    this.escolherOpcao('NU_TIPO_PAGM', this.pagamentoOptions, value);
    this.tipoPagamento();
    this.isPagamentoPixVisivel = false;
  }

  escolherBandeiraCartao(value: any): void {
    this.escolherOpcao('BND_CART', this.bandeiraCartaoOptions, value);
  }

  escolherOpcao(campo: string, options: any[], value: any): void {
    const selecionado = options.find(
      opcao => String(opcao.value) === String(value)
    );
    this.atualizarCampo(campo, selecionado?.value);
  }

  atualizarCampo(campo: string, valor: any): void {
    if (
      this.form.controls[campo as keyof typeof this.form.controls].value !==
      valor
    ) {
      const value = valor ?? '';
      this.form.controls[campo as keyof typeof this.form.controls].setValue(
        value as never
      );

      if (value == 'pix') {
        this.generateQRCode();
      }
    }
  }

  tipoPagamento() {
    const tipoCartao: string[] = ['debit', 'credit'];
    this.isCartao = false;

    this.form.controls['NM_CART'].clearValidators();
    this.form.controls['NU_CART'].clearValidators();
    this.form.controls['DT_EXPC'].clearValidators();
    this.form.controls['CD_SEGU'].clearValidators();

    this.form.controls['NM_CART'].updateValueAndValidity();
    this.form.controls['NU_CART'].updateValueAndValidity();
    this.form.controls['DT_EXPC'].updateValueAndValidity();
    this.form.controls['CD_SEGU'].updateValueAndValidity();

    if (tipoCartao.includes(this.form.controls['NU_TIPO_PAGM'].value)) {
      this.isCartao = true;
      this.form.controls['NM_CART'].setValidators([Validators.required]);
      this.form.controls['NU_CART'].setValidators([
        Validators.required,
        Validators.minLength(16)
      ]);
      this.form.controls['DT_EXPC'].setValidators([Validators.required]);
      this.form.controls['CD_SEGU'].setValidators([
        Validators.required,
        Validators.minLength(3)
      ]);

      this.form.controls['NM_CART'].updateValueAndValidity();
      this.form.controls['NU_CART'].updateValueAndValidity();
      this.form.controls['DT_EXPC'].updateValueAndValidity();
      this.form.controls['CD_SEGU'].updateValueAndValidity();
    }

    return this.isCartao;
  }

  tipoAcesso() {
    const errorList = [undefined, null, ''];
    if (errorList.includes(localStorage.getItem('id'))) {
      return false;
    }

    return true;
  }

  generateQRCode() {
    this.isLoading = true;
    let payload: ICreatePagamentoPix;

    payload = {
      PK_AGND: this.idAgendamento,
      TX_TIPO_TRSC: 'pix'
    };

    this.pagamentoService.CreatePixTransacao(payload, this.guid).subscribe({
      next: (response: ICreatePagamentoPixResponse) => {
        this.isPagamentoPixVisivel = true;
        this.qrcodetext = response.qrCodeResponse.qrCodeData;
        this.dataExpiracao = new Date(
          new Date().getTime() + 15 * 60 * 1000
        ).toISOString();

        QRCode.toDataURL(
          this.qrcodetext,
          {
            width: 500,
            margin: 2,
            color: {
              dark: '#000',
              light: '#fff'
            }
          },
          (err, url) => {
            if (err) throw err;
            this.qrcodeUrl = url;
          }
        );

        this.inicializarCountdown();

        const dataExpiracaoFormatada = formatarData(this.dataExpiracao);
        this.swalAlert.showAlert(
          'Pix gerado',
          `O pix foi gerado, você tem até ${dataExpiracaoFormatada} para realizar o pagamento, caso ultrapasse, o agendamento será cancelado.`,
          'info',
          false,
          false,
          undefined
        );
        this.isLoading = false;
      },
      error: (err) => {
        this.swalAlert.handleError(
          err,
          'Atenção',
          'Tivemos um problema ao gerar o pix, tente novamente.',
          'warning'
        );

        this.isLoading = false;
      }
    });
  }

  setQRCode(response: IGetPagamentoIncompletoByAgendamento) {
    this.form.controls['NU_TIPO_PAGM'].setValue('pix');
    this.form.controls['NU_TIPO_PAGM'].disable();

    this.dataExpiracao = response.DT_QR_EXPR;
    this.isPagamentoPixVisivel = true;
    this.qrcodetext = response.TX_QR_DATA;
    this.dataExpiracao = new Date(
      new Date().getTime() + 15 * 60 * 1000
    ).toISOString();

    QRCode.toDataURL(
      this.qrcodetext,
      {
        width: 500,
        margin: 2,
        color: {
          dark: '#000',
          light: '#fff'
        }
      },
      (err, url) => {
        if (err) throw err;
        this.qrcodeUrl = url;
      }
    );

    this.inicializarCountdown(response.DT_QR_EXPR);
  }

  validarData(data: string): boolean {
    const dataAgendamento = new Date(data);
    if (new Date() > dataAgendamento) {
      this.swalAlert.showAlert(
        'Atenção',
        'O prazo do agendamento venceu.<br>Por favor, realize um novo agendamento.',
        'warning',
        false,
        false,
        undefined
      );
      this.router.navigate(['empresa/listagem/agendamento']);

      return false;
    }
    return true;
  }

  copiarValor(valor: string) {
    const el = document.createElement('textarea');
    el.value = valor;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    this.swalAlert.showAlert(
      'Copiado!',
      'Código pix copiado copiado com sucesso.',
      'warning',
      false,
      false,
      undefined
    );
  }

  navegar() {
    this.router.navigate(['empresa/listagem/agendamento']);
  }

  loadClearSaleSession() {
    (function (a: any, b: any, c: any, d: any, e: any, f?: any, g?: any) {
      a['CsdpObject'] = e;
      ((a[e] =
        a[e] ||
        function () {
          (a[e].q = a[e].q || []).push(arguments);
        }),
        (a[e].l = 1 * new Date().getTime()));
      ((f = b.createElement(c)), (g = b.getElementsByTagName(c)[0]));
      f.async = 1;
      f.src = d;
      g.parentNode.insertBefore(f, g);
    })(window, document, 'script', '//device.clearsale.com.br/p/fp.js', 'csdp');

    csdp('app', String(data.sessionID ?? 'd8i3o907tc74b5gqqyp2'));
    csdp('outputsessionid', 'SESSION_ID');

    setTimeout(() => {
      this.getSessionId();
    }, 500);
  }

  getSessionId(): string {
    const sessionIdInputElement = document.getElementById(
      'SESSION_ID'
    ) as HTMLInputElement | null;

    return sessionIdInputElement?.value ?? '';
  }

  async getIpAddress(): Promise<void> {
    const res = await this.userIpService.getIpAddress().toPromise();
    this.ipAddress = res.ip ?? '';
  }

  verifyPagamentoByAgendamento(idAgendamento: number) {
    this.isLoading = true;
    this.pagamentoService
      .GetPagamentoIncompletoByAgendamento(idAgendamento)
      .subscribe({
        next: (response: IGetPagamentoIncompletoByAgendamento) => {
          this.form.controls['VL_SRVC'].setValue(
            response.VL_SRVC.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          );
          if (response.IsStored) {
            if (response.FL_TIPO_PGMT == 'pix') {
              this.form.controls['NU_TIPO_PAGM'].setValue('pix');
              this.form.controls['NU_TIPO_PAGM'].disable();

              this.dataExpiracao = response.DT_QR_EXPR;
              this.isPagamentoPixVisivel = true;
              this.qrcodetext = response.TX_QR_DATA;
              this.dataExpiracao = new Date(
                new Date().getTime() + 15 * 60 * 1000
              ).toISOString();

              QRCode.toDataURL(
                this.qrcodetext,
                {
                  width: 500,
                  margin: 2,
                  color: {
                    dark: '#000',
                    light: '#fff'
                  }
                },
                (err, url) => {
                  if (err) throw err;
                  this.qrcodeUrl = url;
                }
              );

              this.inicializarCountdown(response.DT_QR_EXPR);
            } else if (response.FL_TIPO_PGMT == 'debit') {
              this.form.disable();
              this.isFormValid = false;
              this.isCartao = false;
              this.urlDebito = response.TX_DEBT_URL;
              this.ifAfterPost = true;
              this.isDebit = true;
            }
          }

          this.isLoading = false;
        },

        error: () => {
          this.router.navigate(['empresa/listagem/agendamento']);
        }
      });
  }
}
